import { queryKeys } from "@/lib/query-keys";
import { useApiInstance } from "@/providers/api-provider";
import { useQuery } from "@tanstack/react-query";

export type Org = {
  id: string;
  name: string;
  logoUrl?: string;
};

export type OrgUser = {
  id: string;
  email: string;
  name: string;
};

export function useLicenseOrgs() {
  return useQuery({
    queryKey: queryKeys.licenseOrgs,
    queryFn: async (): Promise<Org[]> => {
      const response = await useApiInstance.get<Org[]>("/api/v1/licenses/organizations");
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
  });
}

export function useOrgUsersForLicense(orgId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: queryKeys.orgUsersForLicense(orgId || ""),
    queryFn: async (): Promise<OrgUser[]> => {
      if (!orgId) return [];
      const response = await useApiInstance.get<OrgUser[]>(`/api/v1/licenses/organizations/${orgId}/users`);
      return response.data;
    },
    enabled: enabled && !!orgId,
    staleTime: 5 * 60 * 1000,
  });
}
